import { useCallback, useState } from 'react';

// The value is nullable because the numeric input backed by this hook clears to
// null while the field is empty. `Number(prev)` keeps the original coercion, so
// incrementing from null still yields 1.
const useCounter = (initialValue: number | null) => {
  const [value, setValue] = useState<number | null>(initialValue);

  const increment = useCallback(() => setValue(prev => Number(prev) + 1), []);

  // Floors at 1 rather than 0.
  const decrement = useCallback(
    () => setValue(prev => (Number(prev) - 1 === 0 ? prev : Number(prev) - 1)),
    []
  );

  const setTo = setValue;

  return {
    value,
    increment,
    decrement,
    setTo,
  };
};

export default useCounter;
